package org.molap.dataframe

inline fun <R, reified V> columnOf(noinline values: (R) -> V): Column<R, V> =
    Column(V::class, values)

inline fun <R, reified V> column(noinline values: R.() -> V) =
    Column(V::class, values)